import { LogoFooterSetUpIcon } from '@/components/icons'
import { Stack } from '@mui/material'
import SetUpHeader from '../../common/SetUpHeader'
import SetUpLayout from '../../common/SetUpLayout'
import LayoutCenter from './LayoutCenter'

type Props = {}

const ConfigSetUp = (props: Props) => {
  return (
    <SetUpLayout
      title="Config Setup"
      header={<SetUpHeader hideSelect />}
      footer={
        <Stack sx={{ color: '#D7D7D7', alignItems: 'center', mb: '60px' }}>
          <LogoFooterSetUpIcon />
        </Stack>
      }
    >
      <Stack alignItems="center">
        <LayoutCenter />
      </Stack>
    </SetUpLayout>
  )
}

export default ConfigSetUp
